var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-price-pkg"},[_c('div',{staticClass:"c-price-pkg-block"},[_c('Pricing',{attrs:{"pricingList":_vm.pkgList,"isLiuziPage":_vm.isLiuziPage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }